import axiosCall from './interceptor';
import URL from '../helper';

//Fetch Product list
export const getProductList = async () => {
    const url = `${URL.BASE_URL}products`;
    let response = await axiosCall('get', url, {}, false);
    return response?.data;
};

//create ticket
export const createTicket = async (data) => {
    const url = `${URL.BASE_URL}ticket`;
    let response = await axiosCall('post', url, data, false);
    return response?.data;
};

//get ticket list
export const getTicketList = async (data) => {  
    let payload ={};
    if (data?.status ) {
        payload.status = data?.status;
    }
    if (data?.priority) {
        payload.priority = data?.priority;
    }
    const searchParam = new URLSearchParams(payload);
    const url = `${URL.BASE_URL}ticket?${searchParam}&pageNumber=${data.pageNumber}&pageLimit=10`;
    let response = await axiosCall('get', url, {}, false);
    return response?.data;
};

//get ticket list
export const getTicketDeails = async (id) => {
    const url = `${URL.BASE_URL}ticket/${id}`;
    let response = await axiosCall('get', url, {}, false);
    return response?.data;
};

//Add comment
export const addComment = async (data) => {
    const url = `${URL.BASE_URL}comment`;
    let response = await axiosCall('post', url, data, false);
    return response?.data;
};

//Add Image
export const attachImage = async (data) => {
    const url = `${URL.BASE_URL}attachment`;
    let response = await axiosCall('post', url, data, false);
    return response?.data;
};

